import { render } from "./admin-permissions.vue?vue&type=template&id=687a0e6a"
import script from "./admin-permissions.vue?vue&type=script&lang=js"
export * from "./admin-permissions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/applications/admin/admin-permissions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "687a0e6a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('687a0e6a', __exports__)) {
    api.reload('687a0e6a', __exports__)
  }
  
  module.hot.accept("./admin-permissions.vue?vue&type=template&id=687a0e6a", () => {
    api.rerender('687a0e6a', render)
  })

}


export default __exports__